import React from "react";
import { Helmet } from "react-helmet-async";

const ShowConsentScript: React.FC = () => {
  return (
    <Helmet>
      <script type="text/javascript">
        {`
          if (!("cmp_showConsentManager" in window)) {
            window.cmp_showConsentManager = function() {
              if (window.__cmp) {
                window.__cmp('displayConsentUi', {}, function(result) {});
              } else {
                console.warn("Consent Manager ist nicht verfügbar.");
              }
            };
          }
        `}
      </script>
    </Helmet>
  );
};

export default ShowConsentScript;
